import React from "react";
import { useTranslation } from "react-i18next";
import OfferCountdownTimer from "../reuseable/OfferCountdownTimer";
import { isProductOfferActive } from "../reuseable/ProductPriceDisplay";

const PlaceCartItem = ({ 
  title, 
  thumbnail, 
  quantity, 
  altName, 
  price,
  original_price,
  selling_price,
  has_category_offer,
  offer_valid_until
}) => {
  const [_] = useTranslation("global");
  const hasActiveOffer = has_category_offer && selling_price && isProductOfferActive({ has_category_offer, selling_price, offer_valid_until });
  
  return (
    <div className="sku_info d-flex flex-sm-row gap-2 align-items-center">
      <img
        src={thumbnail}
        width="30px"
        style={{ flexGrow: 1, borderRadius:'10px' }}
        alt=""
      />
      <div className="sku_info_text flex-grow-1">
        <p style={{ color: "rgba(23, 43, 77, 1)" }}>{title}</p>
        <p>عدد {quantity}</p>
      </div>
      <div
        className="sku_info_text flex-grow-1"
        style={{ color: "rgba(89, 198, 201, 1)" }}
      >
        <p>{_('home.price')}</p>
        {hasActiveOffer ? (
          <div className="d-flex flex-column">
            <p className="mb-0">
              <del className="text-secondary" style={{ fontSize: "0.85em" }}>
                {original_price || price} {altName}
              </del>
            </p>
            <p className="mb-0" style={{ color: "#dc3545", fontWeight: "bold" }}>
              {selling_price} {altName}
            </p>
            <OfferCountdownTimer 
              offerValidUntil={offer_valid_until} 
              compact={true}
            />
          </div>
        ) : (
          <p>
            {price} {altName}
          </p>
        )}
      </div>
    </div>
  );
};

export default PlaceCartItem;
